import React, { useEffect, useState } from 'react';
import { useForm } from '@mantine/form';
import { TextInput, Button, Group, Title, Checkbox, Select } from '@mantine/core';
import { notifications } from '@mantine/notifications';
import { IconCheck } from '@tabler/icons-react';
import { getPartners, saveBranch, updateBranch } from '../../services/api.service';

const BranchForm = ({ closeModal, isEdit, branch }) => {

	// Hooks
	const [isLoading, toggleLoading] = useState(false);
	const [partners, setPartners] = useState([]);
	const form = useForm({
		initialValues: {
			name: '',
			address: '',
			latitude: '',
			longitude: '',
			partner: {
				id: 0,
			},
			active: true
		},
	});

	// Check if edit
	useEffect(() => {
		if (isEdit) form.setValues({
			name: branch.name,
			address: branch.address,
			latitude: branch.latitude,
			longitude: branch.longitude,
			partner: {
				id: branch.partner?.id,
			},
			active: branch.active,
		});
		// eslint-disable-next-line
	}, []);

	// On load
	useEffect(() => {

		// Get partners
		getPartners(function (response) {

			// Loop partners
			var partners = [];
			for (var i = 0; i < response.data.length; i++) {

				// Assign
				partners.push({
					label: response.data[i].name,
					value: response.data[i].id,
				});

			}

			// Set state
			setPartners(partners);

		}, function (error) {

			// Show error
			notifications.show({
				title: 'Error',
				message: error,
				color: 'red'
			});

		});

	}, []);

	// Submit form
	const onSubmit = (values) => {

		// Set loader
		toggleLoading(true);

		// Conditions
		if (!isEdit) {

			// Call API
			saveBranch(values, function () {

				// Show success
				notifications.show({
					title: 'Sucursal creada correctamente',
					color: 'green',
					icon: <IconCheck />
				});

				// Close after 1 second
				setTimeout(() => {

					// Close modal
					closeModal();

				}, 1000);

			}, function (error) {

				// Remove preloader
				toggleLoading(false);

				// Show error
				notifications.show({
					title: 'Error',
					message: error?.message?.[0] || 'Error inesperado.',
					color: 'red'
				});

			});

		} else {

			// Call API
			updateBranch(branch.id, values, function () {

				// Show success
				notifications.show({
					title: 'Sucursal modificada correctamente',
					color: 'green',
					icon: <IconCheck />
				});

				// Close after 1 second
				setTimeout(() => {

					// Close modal
					closeModal();

				}, 1000);

			}, function (error) {

				// Remove preloader
				toggleLoading(false);

				// Show error
				notifications.show({
					title: 'Error',
					message: error?.message?.[0] || 'Error inesperado.',
					color: 'red'
				});

			});

		}

	}

	return (
		<>
			{/* Form */}
			<form onSubmit={form.onSubmit(onSubmit)}>
				{/* Title */}
				<Title
					order={5}
					mb="md"
				>
					{isEdit ? 'Modificar' : ''} Información de la Sucursal
				</Title>
				{/* Input Group */}
				<Group grow>
					{/* Active */}
					<Checkbox
						label="Activa"
						checked={form.values.active}
						onChange={(event) => form.setFieldValue('active', event.currentTarget.value)}
						{...form.getInputProps('active')}
					/>
				</Group>
				{/* Input Group */}
				<Group
					grow
					mt="md"
				>
					{/* Name */}
					<TextInput
						required
						label="Nombre"
						placeholder="Nombre de la sucursal"
						value={form.values.name}
						onChange={(event) => form.setFieldValue('name', event.currentTarget.value)}
						{...form.getInputProps('name')}
					/>
					{/* Address */}
					<TextInput
						required
						label="Dirección"
						placeholder="Calle, número, ciudad, código postal"
						value={form.values.address}
						onChange={(event) => form.setFieldValue('address', event.currentTarget.value)}
						{...form.getInputProps('address')}
					/>
				</Group>
				{/* Input Group */}
				<Group
					grow
					mt="md"
				>
					{/* Latitude */}
					<TextInput
						required
						label="Latitud"
						placeholder="0"
						value={form.values.latitude}
						onChange={(event) => form.setFieldValue('latitude', event.currentTarget.value)}
						{...form.getInputProps('latitude')}
					/>
					{/* Longitude */}
					<TextInput
						required
						label="Longitud"
						placeholder="0"
						value={form.values.longitude}
						onChange={(event) => form.setFieldValue('longitude', event.currentTarget.value)}
						{...form.getInputProps('longitude')}
					/>
				</Group>
				{/* Input Group */}
				<Group
					grow
					mt="md"
				>
					{/* Partner ID */}
					<Select
						searchable
						withinPortal
						required
						label="Partner"
						placeholder="Busca un partner"
						value={form.values.partner.id}
						onChange={(event) => form.setFieldValue('partner.id', event.currentTarget.value)}
						{...form.getInputProps('partner.id')}
						nothingFound="Sin resultados"
						data={partners}
					/>
				</Group>
				{/* Buttons */}
				<Group
					position="apart"
					grow={!isEdit}
				>
					{/* Cancel */}
					<Button
						mt="xl"
						color="red"
						onClick={closeModal}
						disabled={isLoading}
						variant="light"
						sx={{ flexGrow: isEdit ? 2 : 1 }}
					>
						Cancelar
					</Button>
					{/* Submit */}
					<Button
						mt="xl"
						type="submit"
						loading={isLoading}
						variant="filled"
						sx={{ flexGrow: isEdit ? 2 : 1 }}
					>
						{isEdit ? 'Guardar Cambios' : 'Crear Sucursal'}
					</Button>
				</Group>
			</form>
		</>
	);

}

export default BranchForm;
